export enum BREADCRUMB_STATUS {
    DONE = 'done',
    PROGRESS = 'progress',
    EMPTY = 'empty'
}
